import { render, staticRenderFns } from "./SaldoBancoHoras.vue?vue&type=template&id=d2866004&"
import script from "./SaldoBancoHoras.vue?vue&type=script&lang=js&"
export * from "./SaldoBancoHoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports